// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_og-5";
export var filledCircle = "_og-4";
export var historyEntry = "_og-3";
export var messageSideLeft = "_og-1";
export var messageSideRight = "_og-2";
export var orderTrackingCarouselWrapper = "_og-6";
export var orderTrackingInfoContainer = "_og-0";